import { render, staticRenderFns } from "./MetadataSearchResultDetails.vue?vue&type=template&id=d8ebacb6"
import script from "./MetadataSearchResultDetails.vue?vue&type=script&lang=js"
export * from "./MetadataSearchResultDetails.vue?vue&type=script&lang=js"
import style0 from "./MetadataSearchResultDetails.vue?vue&type=style&index=0&id=d8ebacb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports